import React from 'react';
import moment from 'moment';
import { Modal, Table, Button } from 'react-bootstrap';

export default function ShowTimeslots(props) {
  const { stations, perTimeSlot, showTimeslots, hideTimeslots, totalTimeslots } = props;
  const timeSlotHeader = { position: 'sticky', background: "white", top: 0, };

  return <Modal size="lg" show={showTimeslots} onHide={() => hideTimeslots()}>
    <Modal.Header closeButton>
      <Modal.Title>Timeslots</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div style={{ maxHeight: '500px', overflow: 'auto' }}>
        <Table striped bordered>
          <thead>
            <tr>
              <th style={timeSlotHeader}>#</th>
              <th style={timeSlotHeader}>Vaccines</th>
              <th style={timeSlotHeader}>Time</th>
              <th style={timeSlotHeader}>Date</th>
            </tr>
          </thead>
          <tbody>
            {totalTimeslots && totalTimeslots.map(((timeslot, index) => {
              return <tr key={index}>
                <td>{index + 1}</td>
                <td>{perTimeSlot * stations}</td>
                <td>{moment(timeslot).format("LT")}</td>
                <td>{moment(timeslot).format("L")}</td>
              </tr>
            }))}
          </tbody>
        </Table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={() => hideTimeslots()} >Close</Button>
    </Modal.Footer>
  </Modal>
}
